const resources = {
    showMore: 'Afficher plus de produits',
    breadcrumb: 'Breadcrumb',
    viewing: 'Affichage',
    results: 'résultats'
};

module.exports = function getResource(label) {
    return resources[label];
};
